import styled from 'styled-components';

export const MetadataMultidiscountsContainer = styled.div`
    max-height: 200px;
    overflow: auto;

    .discounts .discount {
        .value {
            font-size: 12px;
        }
        color: ${props => props.theme.partnerOfferSecond};
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/metadata/ModalMultiDiscountComponentStyle.js